/**
 * Module-level cache for nodes by graphId.
 * Used within React components to cache node lists and invalidate on graph changes.
 * This cache persists across component instances using module-level Maps.
 */

// Cache structure: { graphId: nodes[] }
export const nodesCache = new Map();

// Track cache version per graphId for invalidation
export const cacheInvalidationKey = new Map();

/**
 * Invalidate cache for a specific graph
 * @param {string} graphId - Graph identifier
 */
export const invalidateNodeCache = (graphId) => {
  if (graphId) {
    const currentVersion = cacheInvalidationKey.get(graphId) || 0;
    cacheInvalidationKey.set(graphId, currentVersion + 1);
    nodesCache.delete(graphId);
  }
};

/**
 * Get the current cache version for a graph
 * @param {string} graphId - Graph identifier
 * @returns {number} Current cache version
 */
export const getCacheVersion = (graphId) => {
  return graphId ? (cacheInvalidationKey.get(graphId) || 0) : 0;
};

